export const matchRoutes = (pathname: string, routes: string[] | undefined) => {
  const path = pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;

  return routes ? routes.includes(path) : false;
};
